<template>
  <section>
    <div class="container box mt-5">
      <h1 class="title">Declaración Compromisos de Desempeño {{ year }}</h1>

      <div
        v-if="
          performanceInfo.is_extend_phase_term !== undefined &&
          performanceInfo.is_extend_phase_term !== null &&
          performanceInfo.is_extend_phase_term === true
        "
        class="columns is-centered"
      >
        <div class="column is-10 is-centered">
          <b-message
            type="is-info"
            has-icon
            title="Importante"
            aria-close-label="Close message"
          >
            Se encuentra en una fase de extensión de plazo para declarar sus
            compromisos de desempeño. Por favor, complete la información
            requerida antes de que finalice el proceso.
          </b-message>
        </div>
      </div>

      <div
        v-if="
          performanceInfo.state !== undefined &&
          performanceInfo.state !== null &&
          performanceInfo.state === 'DEVUELTA'
        "
        class="columns is-centered"
      >
        <div class="column is-10 is-centered">
          <b-message
            type="is-warning"
            has-icon
            title="Importante"
            aria-close-label="Close message"
          >
            Este compromiso de convenio de desempeño fue devuelto por el/la
            Director/a de departamento, con la siguiente observación:<br />
            <b
              ><span class="preserve-line-breaks">{{
                performanceInfo.comment
              }}</span></b
            >
          </b-message>
        </div>
      </div>

      <div class="columns mb-6 is-centered">
        <div class="column is-10 is-bordered-grey">
          <AcademicConsolidated
            :academic_areas="academic_areas"
            :performances="performances"
          />
        </div>
      </div>

      <b-tabs position="is-centered">
        <b-tab-item
          v-for="(academic_area, index) in academic_areas"
          :key="index"
          :label="academic_area.alt_name"
        >
          <AddCommitmentComponent
            :performances="performances"
            :academicArea="academic_area"
            @refreshPerfomance="refreshPerfomance"
            @addCommitment="addCommitment"
            :subjects="subjects"
            :my-subjects="my_subjects"
          />
        </b-tab-item>
      </b-tabs>

      <div class="columns">
        <div class="column has-text-centered">
          <b-button
            label="Ver Detalle Declaración"
            type="is-primary"
            icon-left="eye"
            tag="a"
            :href="`/performances/process/${year}/person/${person.id}`"
          />
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
  </section>
</template>

<script>
import axios from "axios";
import AcademicConsolidated from "./AcademicConsolidated.vue";
import AddCommitmentComponent from "./AddCommitmentComponent.vue";
import moment from "moment";
export default {
  name: "NewPerformances",

  props: {
    canDeclare: {
      type: Boolean,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
    person: {
      type: Object,
      required: true,
    },
  },

  components: {
    AcademicConsolidated,
    AddCommitmentComponent,
  },

  data() {
    return {
      //Datos a traer
      academic_areas: [],
      performanceInfo: {},

      //Datos a guardar
      performances: [],

      //Auxiliares
      isLoading: false,
      subjects: [],
      my_subjects: [],
      my_real_hours_subjects: [],
    };
  },

  async created() {
    if (!this.canDeclare) {
      this.$buefy.dialog.alert({
        title: "Error",
        message:
          "En estos momentos no se encuentra una fase activa para declarar, vuelva en otro momento.",
        type: "is-danger",
        hasIcon: true,
        iconPack: "fa",
        icon: "times-circle",
        confirmText: "Ok",
        onConfirm: () => {
          window.location.href = "/";
        },
      });
    }
    await this.getAcademicAreas();
    await this.getPerformanceInfoForAcademic();
    await this.getSubjects();
    await this.getMySubjects();
  },

  methods: {
    async getAcademicAreas() {
      this.isLoading = true;
      await axios
        .get("/academic_areas.json")
        .then((response) => {
          this.academic_areas = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getPerformanceInfoForAcademic() {
      this.isLoading = true;
      await axios
        .get("/performances/get-performance-info-for-academic.json", {
          params: {
            person_id: this.person.id,
          },
        })
        .then((response) => {
          this.performanceInfo = response.data;

          const state_performance = this.performanceInfo.state;

          if (
            state_performance === "EMITIDA" ||
            state_performance === "ACEPTADA"
          ) {
            window.location.href = `/performances/process/${this.year}/person/${this.person.id}`;
          }

          this.performanceInfo.phase.start_date = moment(
            this.performanceInfo.phase.start_date,
            ["YYYY-MM-DD", "DD-MM-YYYY"]
          );
          this.performanceInfo.phase.end_date = moment(
            this.performanceInfo.phase.end_date,
            ["YYYY-MM-DD", "DD-MM-YYYY"]
          );

          this.performances = this.performanceInfo.activity_performances
            ? this.performanceInfo.activity_performances
            : [];
          let index = 1;
          this.performances.forEach((performance) => {
            performance.commitment_index = index;
            index++;
          });
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getSubjects() {
      this.isLoading = true;
      axios
        .get("/performances/sai-subjects.json")
        .then((response) => {
          this.subjects = response.data;
          this.subjects.push({
            codigo: -1,
            electividad: -1,
            electivo: "N",
            nombre: "OTROS",
            sct: -1,
            tel: "0-0-0",
            tipo: "",
            titulacion: "",
            alt_nombre: "Otros",
            codigo_nombre: "OTROS",
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getMySubjects() {
      this.isLoading = true;
      axios
        .get(`/performances/my-sai-subjects/${this.year - 1}.json`)
        .then((response) => {
          this.my_subjects = response.data;
          console.log(this.my_subjects);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addCommitment(commitment) {
      this.performances.push(commitment);
      this.performances.sort(function (a, b) {
        return a.commitment_index - b.commitment_index;
      });
    },

    refreshPerfomance(commitment, isCommitmentDelete) {
      this.performances = this.performances.filter(
        (comm) => comm.commitment_index != commitment.commitment_index
      );
      if (isCommitmentDelete) {
        this.performances.forEach((performance, index) => {
          performance.commitment_index = index + 1;
        });
      }
    },
  },
};
</script>

<style scoped>
.preserve-line-breaks {
  white-space: pre-line;
}
</style>
